// src/App.jsx
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';        // Home page only
import NavbarAll from './components/NavbarAll';  // All other pages
import Navbar2 from './components/Navbar2';  // All other pages

import Home from './pages/Home';
import AkijTextileMills from './pages/AkijTextileMills';
import AkijBakers from './pages/AkijBakers';
import AkijFlourMills from './pages/AkijFlourMills';
import AkijPrinting from './pages/AkijPrinting';
import LighthouseInternational from './pages/LighthouseInternational';
import AkijFoundation from './pages/AkijFoundation';
import MonowaraActiveTechnical from './pages/MonowaraActiveTechnical';
import Contact from './pages/Contact';

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  console.log('Current Path:', location.pathname); // Debugging
  console.log('isHomePage:', isHomePage); // Should be true only on "/"

  return (
    <>
  {isHomePage ? (
    <>
    {/* Scrolls to top on every page change */}
      <ScrollToTop />
      {/* This is shown only on homepage */}
          {/* <p>Anika</p> */}
          <Navbar/>

      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </>
  ) : (
    <>
    {/* Scrolls to top on every page change */}
      <ScrollToTop />
      {/* This is shown on all other pages */}
            {/* <p>Anas</p> */}
            <Navbar2/>

      <Routes>
        <Route path="/akij-textile-mills" element={<AkijTextileMills />} />
        <Route path="/akij-bakers" element={<AkijBakers />} />
        <Route path="/akij-flour-mills" element={<AkijFlourMills />} />
        <Route path="/akij-printing" element={<AkijPrinting />} />
        <Route path="/Lighthouse-International" element={<LighthouseInternational />} />
        <Route path="/Akij-Foundation" element={<AkijFoundation />} />
        <Route path="/Monowara-Active-Technical" element={<MonowaraActiveTechnical />} />
        <Route path="/Contact" element={<Contact />} />
      </Routes>
    </>
  )}
</>


  );
}

export default App;
